module.exports = __webpack_public_path__ + "static/media/20201129_222405_023_IMG_1962.654d6b0a.jpg";